import { memo } from 'react';
import { getNodeDataByNodeId } from '@/common/reducers/ChatbotSelectors';
import { CommonRootState } from '@/common/types/common-root-state-type';
import { getHandleId, getTargetHandleStyle } from '@common-services/utils';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { Handle, NodeProps, Position } from 'reactflow';
import { CustomNodeData, nodeTypes } from '../bt-nodes-def';
import NodeContainer from '../node-container';
import styles from './agent-node.module.scss';
import SelectToolsDialog from './tools/select-tools-dialog';
import AgentNodeContainer from './agent-node-container';

function AgentNode({ id }: NodeProps<CustomNodeData>) {
    const data = useSelector((state: CommonRootState) => getNodeDataByNodeId(state, id));
    const type = data?.type;
   

    return (
        <>
            <Handle
                type="target"
                position={Position.Left}
                id={getHandleId(data?.handles, 'target', 0) ?? undefined}
                style={{ ...getTargetHandleStyle((type ? nodeTypes?.[type as keyof typeof nodeTypes]?.color : '') ?? ''), zIndex: 3 }}
            />
            <Box className={styles.agentNode}>
                <NodeContainer
                    type={type}
                    title={(type ? nodeTypes[type as keyof typeof nodeTypes]?.title : undefined) || 'Agent'}
                    color={(type ? nodeTypes[type as keyof typeof nodeTypes]?.color : undefined) || 'var(--color-text)'}
                    nodeId={id}
                >
                    <AgentNodeContainer id={id} />
                </NodeContainer>
            </Box>
            {/* <CustomSourceHandle
                type="source"
                position={Position.Right}
                id={getHandleId(data.handles, 'source', 0)}
                style={{ ...getSourceHandleStyle(nodeTypes?.[type]?.color), zIndex: 3 }}
                connectioncount={1}
            /> */}

            {/* Select Tools Dialog */}
            <SelectToolsDialog />
        </>
    );
}

export default memo(AgentNode);